<template>
  <commodity-derivatives
    :Analytics="Analytics"
    :colorTheme="colorTheme"
    :loadingAll="loadingAll"
    :processData="processData"
    :renderChartSignal="renderChartSignal"
    :isPrices="isPrices"
    :idChart="idChart"
    :asset="asset"
    @changeInfoTable="changeInfoTable"
    @onTableFormat="onHoverChart"
  />
</template>
<script>
import CommodityDerivatives from "./CommodityDerivatives.vue";
import { defaultAnalytics } from "@/_core/data/Analytics/AnalyticsHelpers.js";
export default {
  components: { CommodityDerivatives },
  name: "",
  props: {
    Analytics: {
      required: true,
      default: defaultAnalytics()
    },
    colorTheme: { required: true, type: Boolean, default: true },
    loadingAll: { required: true, type: Boolean, default: false },
    processData: { required: true },
    renderChartSignal: { required: true, default: 0 },
    asset: { required: false, default: "commodity" }
  },
  data() {
    return {
      isPrices: false,
      idChart: "qDerivatives"
    };
  },
  methods: {
    changeInfoTable(val) {
      this.$emit("changeInfoTable", val);
    },
    onHoverChart(val) {
      this.$emit("onTableFormat", val);
    }
  }
};
</script>
